<template>
  <form
    action="/cart/add"
    method="post"
    enctype="multipart/form-data"
    novalidate
    ref="productForm"
    @submit.prevent="addToCart"
  >
    <slot></slot>
  </form>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { TablescapeContext, TablescapeEvent } from "@tablescape/context";
import { formatMsrpValue } from "@tablescape/utilities";

export default {
  name: "product-form",
  props: {
    selectId: { type: String, default: "id" },
  },
  computed: {
    ...mapState({
      cart: (state) => state.cart.data,
    }),
    ...mapGetters({
      getProperties: "metafields/getProperties",
    }),
  },
  methods: {
    async addToCart() {
      const form = this.$refs.productForm;
      const { product } = JSON.parse(
        document.querySelector(".js-product-json").innerHTML
      );

      // send activation event for cart containing an always pan
      const mainProductsReg = new RegExp("always-essential-cooking-pan");
      if (mainProductsReg.test(product.handle)) {
        window.dataLayer?.push?.({ event: "cart-contents.always-pan" });
      }

      const formData = new FormData(form);
      const quantity = formData.get("quantity");
      const variantId = formData.get(this.selectId);
      const variantMsrp = formData.get("msrp");
      const upsellActive = formData.get("pdp-upsell-active");

      const items = [];
      const properties = this.getProperties(variantId) ?? [];

      items.push({
        attributes: [
          ...properties,
          {
            key: "_msrp",
            value: formatMsrpValue(variantMsrp),
          },
        ],
        id: variantId,
        quantity: parseInt(quantity),
      });

      if (upsellActive) {
        const upsellVariantId = formData.get("pdp-upsell");
        const upsellProperties = this.getProperties(upsellVariantId) ?? [];
        items.push({
          attributes: [...upsellProperties],
          id: upsellVariantId,
          quantity: parseInt(quantity),
        });
      }

      TablescapeContext.emit(TablescapeEvent.TOGGLE_CART, {
        ui: {
          cartDrawerOpen: true,
          cartDrawerUserToggled: false,
          giftNoteDrawerOpen: false,
          productVariantDrawerOpen: false,
        },
      });
      TablescapeContext.emit(TablescapeEvent.ADD_TO_CART, {
        cart: { lines: items },
      });
    },
  },
  async created() {
    this.$store.dispatch("metafields/fetchMeta");
  },
};
</script>
